<template>
  <div id="games" class="menu-container animated slideInLeft">

    <div class="squareGame animated slideInLeft nosubmenu">
      <router-link to="/" aria-label="Home">
        <div class="imgGame home"></div>
        <transition name="fade">
          <span class="gameTitle" v-if="hover.home || hover.showOtherTitles">Home</span>
        </transition>
      </router-link>
    </div>

    <div class="squareGame animated slideInLeft nosubmenu">
      <router-link to="/about" aria-label="About">
        <div class="imgGame about"></div>
        <transition name="fade">
          <span class="gameTitle" v-if="hover.about || hover.showOtherTitles">About</span>
        </transition>
      </router-link>
    </div>

    <div class="squareGame animated slideInLeft nosubmenu">
      <router-link to="/search" aria-label="Test payments">
        <div class="imgGame search"></div>
        <transition name="fade">
          <span class="gameTitle" v-if="hover.search || hover.showOtherTitles">Search</span>
        </transition>
      </router-link>
    </div>

    <div class="squareGame animated slideInLeft nosubmenu">
      <router-link to="/sign-up" aria-label="Sign-up">
        <div class="imgGame signup"></div>
        <transition name="fade">
          <span class="gameTitle" v-if="hover.signup || hover.showOtherTitles">Sign up</span>
        </transition>
      </router-link>
    </div>

    <div class="squareGame animated slideInLeft nosubmenu">
      <router-link to="/vendors" aria-label="Menu Example">
        <div class="imgGame menu"></div>
        <transition name="fade">
          <span class="gameTitle" v-if="hover.menu || hover.showOtherTitles">Menu Example</span>
        </transition>
      </router-link>
    </div>

    <div class="squareGame animated slideInLeft nosubmenu">
      <router-link to="/vendors" aria-label="Test payments">
        <div class="imgGame test-payment-page"></div>
        <transition name="fade">
          <span class="gameTitle" v-if="hover.payment || hover.showOtherTitles">Test Payment Page</span>
        </transition>
      </router-link>
    </div>
  </div>


</template>
<script>
  import { useAuthStore, fetchWithOrWithoutAuth, fetchWithAuth, refreshToken, startTokenRefreshTimer } from 'shared-vue'
  import { mapState } from 'pinia';

  export default {
    data() {
      return {
        hover: {
          about: false,
          tools: false,
          payment: false,
          signup: false,
          search: false,
          home: false,
          menu: false,
          alwaysShowTitle: true, // Show all titles by default
          showOtherTitles: true // Toggle based on hover state
        },
        isAuthenticated: false,
        showPasswordPrompt: false,
        password: "",
        tools: [] // Holds dynamically fetched tool links
      };
    },
    computed: {
      ...mapState(useAuthStore, ['user']),
      isAdmin() {
        return this.user?.roles?.includes("Admin");
      }
    },
    watch: {
      user(newUser, oldUser) {
        if (newUser && !oldUser && this.isAdmin) {
          //this.fetchTools();
        }
      }
    },
    methods: {
      handleHover(section, isEntering) {
        this.hover.showOtherTitles = isEntering ? false : this.hover.alwaysShowTitle;
        this.hover[section] = isEntering;
      },
      handleSubmenuHover(section, isEntering) {
        // Keep the parent hovered when submenu is hovered
        if (!this.isTouchDevice) {
          this.hover[section] = isEntering;
        }
      },
      toggleMenu(section) {
        // Only use click to toggle for touch devices
        if (this.isTouchDevice) {
          this.hover[section] = !this.hover[section];
        }

      },

    },
    created() {

    }
  };

</script>

<style scoped>
  *, *::before, *::after {
    box-sizing: content-box;
  }

  a {
    color: white;
  }

  .test-payment-page {
    background-color: #ff00ff;
    background-image: url("/assets/onlinePayments.png");
  }

  .about {
    background-color: #ff00ff;
    background-image: url("/assets/wip.png");
  }

  .signup {
    background-color: #ff00ff;
    background-image: url("/assets/signupIcon.png");
  }

  .menu {
    background-color: #ff00ff;
    background-image: url("/assets/menuIcon.png");
  }

  .search {
    background-color: #ff00ff;
    background-image: url("/assets/searchFood.png");
  }

  .home {
    background-color: #ff00ff;
    background-image: url("/assets/homepage.png");
  }

  .menuIcon {
    background-color: #ff00ff;
    background-image: url("/assets/menuIcon.png");
  }
</style>
